import classNames from "classnames";
import {KeyboardEventHandler, ReactNode} from "react";
import {useFormContext} from "react-hook-form";

import {FormLabel} from "@/components/form/FormLabel.tsx";
import {FormSubtext} from "@/components/formSubtext/FormSubtext.tsx";
import {getFormError} from "@/lib/form/form.utils.ts";
import {FieldProps} from "@/pages/checks/components/form/fields/common.ts";

import styles from "./TextAreaField.module.scss";

interface TextAreaFieldProps extends FieldProps {
  rows?: number;
  cols?: number;
  maxLength?: number;
  placeholder?: string;
  onKeyDown?: KeyboardEventHandler<HTMLTextAreaElement>;
  endElement?: ReactNode;
}

export const TextAreaField = ({
  name,
  label,
  className,
  tooltip,
  helpText,
  supportLink,
  required,
  rows,
  cols,
  maxLength,
  placeholder,
  disabled,
  supportLinkText,
  supportLinkPosition,
  onKeyDown,
  endElement,
}: TextAreaFieldProps) => {
  const {
    register,
    formState: {errors},
  } = useFormContext();
  const fieldError = getFormError(name, errors);
  return (
    <div className={className}>
      {label && (
        <FormLabel helpText={tooltip} forId={name} required={required}>
          {label}
        </FormLabel>
      )}
      <div className={styles.textareaWrap}>
        <textarea
          id={name}
          rows={rows}
          cols={cols}
          className={classNames("form-control", {[styles.withEndElement]: !!endElement})}
          {...register(name, {required: required})}
          maxLength={maxLength}
          placeholder={placeholder}
          disabled={disabled}
          onKeyDown={onKeyDown}
        />
        {endElement && <div className={styles.endElement}>{endElement}</div>}
      </div>
      <FormSubtext
        subText={helpText}
        supportLink={supportLink}
        supportLinkText={supportLinkText}
        supportLinkPosition={supportLinkPosition}
        error={fieldError?.toString()}
      />
    </div>
  );
};
